import React, { useMemo } from "react";
import { slimImage } from "@/service/utils";
import { useTranslation } from "react-i18next";

/**横幅 */
export const Chef = ({ chef }) => {
  const { t } = useTranslation();
  const avatar = useMemo(() => {
    return slimImage(chef.photo);
  }, []);
  return (
    <div className="page-restaurant--chef">
      <div className="chef-profile">
        <div className="chef-avatar">
          <img src={slimImage(chef.photo)} alt="" />
        </div>
        <div className="chef-content">
          <div className="chef-head">{t("WEB.The chef")}</div>
          <div className="chef-title">{chef.name}</div>
        </div>
      </div>
      <div className="chef-desc">{chef.description}</div>
    </div>
  );
};
